export interface NavItem {
  id: string;
  path: string;
  label: string;
  icon: string;
  /** Clé du compteur affiché en pastille, alimenté par le dashboard. */
  badgeKey?: 'companies' | 'offers' | 'reviews';
  /** Écran strictement réservé au super-admin. */
  superAdminOnly?: boolean;
}

export interface NavGroup {
  label: string | null;
  items: NavItem[];
}

export const NAV_GROUPS: readonly NavGroup[] = [
  {
    label: null,
    items: [{ id: 'dashboard', path: '/', label: 'Tableau de bord', icon: 'LayoutDashboard' }],
  },
  {
    label: 'Modération',
    items: [
      { id: 'companies', path: '/companies', label: 'Comptes entreprise', icon: 'Building2', badgeKey: 'companies' },
      { id: 'offers', path: '/offers', label: 'Offres', icon: 'Tag', badgeKey: 'offers' },
    ],
  },
  {
    label: 'Contenu',
    items: [
      { id: 'articles', path: '/articles', label: 'Articles', icon: 'Newspaper' },
      { id: 'fruits', path: '/pregnancy', label: 'Suivi de grossesse', icon: 'Baby' },
      { id: 'addresses', path: '/addresses', label: 'Répertoire', icon: 'MapPin', badgeKey: 'reviews' },
    ],
  },
  {
    label: 'Comptes',
    items: [
      { id: 'users', path: '/users', label: 'Utilisatrices', icon: 'Users' },
      { id: 'appointments', path: '/appointments', label: 'Rendez-vous', icon: 'CalendarClock' },
      { id: 'admins', path: '/admins', label: 'Comptes admin', icon: 'ShieldCheck', superAdminOnly: true },
    ],
  },
  {
    label: 'Paramètres & suivi',
    items: [
      { id: 'audit-log', path: '/audit-log', label: "Journal d'audit", icon: 'ScrollText' },
      { id: 'performance', path: '/performance', label: 'Entreprises · Performance', icon: 'BarChart2' },
      { id: 'formulas', path: '/formulas', label: 'Formules & abonnements', icon: 'CreditCard' },
      { id: 'countries', path: '/countries', label: 'Pays disponibles', icon: 'Globe' },
      { id: 'notifications', path: '/notifications', label: 'Notifications', icon: 'Bell' },
      { id: 'mobile-config', path: '/mobile-config', label: 'Configuration app mobile', icon: 'Smartphone' },
      { id: 'article-categories', path: '/article-categories', label: 'Catégories articles', icon: 'BookOpen' },
      { id: 'offer-categories', path: '/offer-categories', label: "Catégories d'offres", icon: 'Layers' },
      { id: 'appointment-reasons', path: '/appointment-reasons', label: 'Motifs de rendez-vous', icon: 'ClipboardList' },
      { id: 'business-types', path: '/business-types', label: "Types d'entreprises", icon: 'Briefcase' },
      { id: 'directory-categories', path: '/directory-categories', label: 'Catégories répertoire', icon: 'FolderOpen' },
    ],
  },
  {
    label: 'Aide',
    items: [{ id: 'help', path: '/help', label: 'Aide & prise en main', icon: 'HelpCircle' }],
  },
];

/** Titre et sous-titre de la barre supérieure, par route. */
export const PAGE_HEADINGS: Record<string, readonly [string, string]> = {
  '/': ["Tableau de bord", "Vue d'ensemble de l'activité"],
  '/companies': ["Comptes entreprise", "Validation des inscriptions professionnelles"],
  '/offers': ["Offres", "Modération des offres partenaires"],
  '/articles': ["Articles", "Contenu éditorial de l'application"],
  '/pregnancy': ["Suivi de grossesse", "Nom et image du fruit associé à chaque semaine"],
  '/addresses': ["Répertoire d'adresses", "Bonnes adresses et modération des avis"],
  '/users': ["Utilisatrices", "Comptes des utilisatrices de l'application"],
  '/appointments': ["Rendez-vous", "Rendez-vous planifiés par les utilisatrices"],
  '/admins': ["Comptes admin", "Modérateurs et super-admins du back-office"],
  '/performance': ["Entreprises · Performance", "Chiffre d'affaires et offres publiées"],
  '/formulas': ["Formules & abonnements", "Formules tarifaires et relance à échéance"],
  '/countries': ["Pays disponibles", "Pays actifs dans l'application et le site"],
  '/notifications': ["Notifications", "Messages automatiques envoyés aux entreprises"],
  '/article-categories': ["Catégories articles", "Catégories affichées dans les articles éditoriaux"],
  '/offer-categories': ["Catégories d'offres", "Catégories affichées dans le fil d'offres de l'application"],
  '/appointment-reasons': ["Motifs de rendez-vous", "Motifs affichés dans l'application mobile"],
  '/business-types': ["Types d'entreprises", "Types affichés dans le répertoire et la gestion des comptes"],
  '/directory-categories': ["Catégories répertoire", "Catégories des bonnes adresses"],
  '/audit-log': ["Journal d'audit", "Historique de toutes les modifications de données"],
  '/mobile-config': ["Configuration app mobile", "Versions minimales et forçage de mise à jour"],
  '/help': ["Aide & prise en main", "Comment utiliser chaque écran du back-office"],
};
